// Copyright (c) 2020 WiseTime. All rights reserved.

import React from "react"
import { Switch, Route, Redirect } from "react-router-dom"
import RouteWrapper from "features/shared/RouteWrapper"
import { ROUTES, ROUTE_PATH, RouteDefinition } from "app/routing"
import { TODAY_DATE_PARAM } from "../features/timeline/dateTime"

const Routes = (): React.ReactElement<unknown> => {
  return (
    <React.Fragment>
      <Switch>
        <Route
          path="/"
          exact
          render={(): React.ReactElement<unknown> =>
            <Redirect to={ROUTE_PATH.TIMELINE.path.replace(":date?", TODAY_DATE_PARAM)} />}
        />
        {
          ROUTES.map((route: RouteDefinition) => (
            <Route
              key={route.title}
              path={route.path}
              exact={route.exact}
              render={(props): React.ReactElement<unknown> => (
                <RouteWrapper
                  route={route}
                  {...props}
                />
              )}
            />
          ))
        }
        <Route component={React.lazy(() => import("app/errors/NotFound"))} />
      </Switch>
    </React.Fragment>
  )
}

export default Routes

